/* eslint-disable react/no-array-index-key */
/* eslint-disable operator-linebreak */

import { Show, ThemeTokens } from '@acp/core-ui';
import {
    RegionUtil, useAgencySettings, useExperiment, useSession,
} from '@acp/feature/auth';
import { Box } from '@chakra-ui/react';
import { Role } from '@acp/shared';
import { DesktopNavigation } from './desktop-navigation/desktop-navigation';
import { MobileNavigation } from './mobile-navigation/mobile-navigation';
import { AppNavigationItem, DropdownMenuItem } from './types';

export function AppNavigation({
    navItems,
}: {
    navItems: AppNavigationItem[];
}) {
    const { complianceAgencyState, isComplianceAgencyUserMaster } = useSession();
    const experiments = useExperiment();
    const {
        agencySettings,
    } = useAgencySettings();

    const applyStateFilter = (item: AppNavigationItem | DropdownMenuItem) => {
        if (item.applicableStates === null) {
            return true;
        }

        return RegionUtil.isIncludedState(
            item.applicableStates,
            complianceAgencyState
        );
    };

    const applyRoleFilter = (item: AppNavigationItem | DropdownMenuItem) => {
        if (item.applicableRoles === null) {
            return true;
        }

        return isComplianceAgencyUserMaster && item.applicableRoles.includes(Role.Master);
    };

    const applyExperimentFilter = (item: AppNavigationItem | DropdownMenuItem) => {
        if (item.applicableExperiment == null) {
            return true;
        }

        return experiments?.hasExperiment(item.applicableExperiment);
    };

    const applyAgencySettingsFilter = (item: AppNavigationItem | DropdownMenuItem) => {
        if (item.applicableAgencySettings == null) {
            return true;
        }

        if (agencySettings === undefined) {
            return false;
        }

        return item.applicableAgencySettings(agencySettings);
    };

    const applyFilters = (
        item: AppNavigationItem | DropdownMenuItem
    ) => applyStateFilter(item)
    && applyRoleFilter(item)
    && applyExperimentFilter(item)
    && applyAgencySettingsFilter(item);

    const items = navItems
        .filter((navItem) => applyFilters(navItem))
        .map((navItem) => ({
            ...navItem,
            dropdownItems: navItem.dropdownItems?.filter(
                (dropdownItem) => applyFilters(dropdownItem)
            ),
        }));

    return (
        <>
            {/* mobile header */}
            <Box display={{ base: 'block', md: 'none' }}>
                <MobileNavigation navItems={items} />
            </Box>

            {/* desktop header */}
            <Show above={ThemeTokens.Defaults.mobileMenuBreakpoint}>
                <DesktopNavigation navItems={items} />
            </Show>
        </>
    );
}
